import * as api from '../api/index.js';
import QuotaUsersScreen from '../components/QuotaUsersScreen';

export default function ReassignQuotaUsersPage() {
  return (
    <QuotaUsersScreen
      variant="reassign"
      title="Reassign Quota"
      subtitle="Load all study users, review quota assignments, filter by respondent fields, and reassign quotas. Over-quota users can be saved individually; use bulk swap for batch changes."
      fetchUsersApi={api.getReassignQuotaUsers}
    />
  );
}
